export default "__VITE_ASSET__X$uiMGUD__"